import '@fortawesome/fontawesome-free/css/all.min.css'
import 'bootstrap-css-only/css/bootstrap.min.css'
import 'mdbvue/lib/css/mdb.min.css'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

import Notify from 'mdbvue/lib/components/Notify'
Vue.use(Notify)

import VueMobileDetection from 'vue-mobile-detection'
Vue.use(VueMobileDetection)

Vue.component('v-menu', require('./components/menu').default)
Vue.component('v-streak', require('./components/streak').default)
Vue.component('v-infoUndraw', require('./components/info_undraw').default)
Vue.component('v-infoMain', require('./components/infoMain').default)
Vue.component('v-infoDetails', require('./components/infoDetails').default)
Vue.component('v-enlases', require('./components/enlases').default)
Vue.component('v-galeria', require('./components/galeria').default)
Vue.component('v-footer', require('./components/main_footer').default)



new Vue({
    router,
    store,
    render: function(h) { return h(App) }
}).$mount('#app')